import { Directive, ElementRef, OutputEmitterRef, inject, output } from '@angular/core';

@Directive({
  selector: '[appHoverXPosition]',
  host: {
    '(mousemove)': 'onMouseMove($event)',
    '(mouseleave)': 'hoverXPosition.emit(null)',
  },
})
export class HoverXPosition {
  private el: ElementRef = inject(ElementRef);

  hoverXPosition: OutputEmitterRef<number | null> = output<number | null>();

  onMouseMove(event: MouseEvent) {
    const rect: DOMRect = this.el.nativeElement.getBoundingClientRect();
    const x: number = event.clientX - rect.left;
    this.hoverXPosition.emit(x);
  }
}
